export enum HelpAbsoluteRoutes {
  ROOT = 'help',
}
